<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <v-row class="mt-0 mb-2" justify="space-between" no-gutters>
        <v-col cols="12" md="4">
          <v-card class="py-3 px-4 vcard_area">
            <v-row>
              <v-col cols="12" md="7">
                <div class="text-h1 mb-2">Bancos e financeiras</div>
                <div class="text text--thin mb-2">Os logotipos serão exibidos junto com a forma de pagamento a prazo nas propostas.</div>
                <v-btn v-if="$root.Permissions.admin()" @click="dialogNovo = true" color="primary" class="mt-1"><v-icon class="mr-1">account_balance</v-icon>Novo banco</v-btn>
              </v-col>
              <v-col cols="12" md="5">
                <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                  <v-icon>add</v-icon>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="dados"
        disable-sort
        :server-items-length="total"
        :options.sync="options"
        loading-text="Carregando... Por favor aguarde"
        :loading="carregando"
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <v-row no-gutters>
              <div class="py-2 px-2">
                <v-form @submit.prevent="applyFilter()">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="search"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
              </div>
              <div class="py-2 px-2" v-if="$root.Permissions.admin()">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="distribuidor"
                  :items="distribuidores"
                  hide-details=""
                  clearable
                  clear-icon="close"
                  label="Distribuidor"
                  append-icon="expand_more"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </div>
              <div class="py-2 px-2" v-if="$root.Permissions.admin()">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="integrador"
                  :items="integradores"
                  hide-details=""
                  clearable
                  clear-icon="close"
                  label="Integrador"
                  append-icon="expand_more"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </div>
            </v-row>
            <div>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Exportar
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="exportXls()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para XLS</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </template>
        <template v-slot:item.ban_nome="{ item }">
          <v-tooltip top v-if="item.opcoes && item.opcoes.length && $root.Permissions.integrator()">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="primary" class="mr-2">
                check
              </v-icon>
            </template>
            <span>Opções de financiamento configuradas</span>
          </v-tooltip>
          {{ item.ban_nome }}
        </template>
        <template v-slot:item.ban_logo="{ item }">
          <img class="banco_imagem" :src="item.ban_logo" alt="Imagem">
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top v-if="$root.Permissions.admin()">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openNovo(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top v-if="!$root.Permissions.admin()">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialogConfig(item)" color="primary">
                  settings
                </v-icon>
              </template>
              <span>Configurações</span>
            </v-tooltip>
            <v-tooltip top v-if="$root.Permissions.admin()">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="500px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{banco.uuid_ban_id ? 'Editar banco' : 'Novo banco'}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formBancos">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-text-field
                v-model="banco.ban_nome"
                label="Nome*"
                :rules="[rules.required]"
                autofocus
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-file-input
                show-size
                clearable
                ref="file"
                v-model="banco.ban_logo"
                prepend-icon="image"
                label="Adicionar logotipo*"
                :rules="[rules.required, rules.size]"
                clear-icon="close"
                truncate-length="50"
                :loading="salvando"
                :disabled="salvando"
                v-if="isObject(banco.ban_logo)"
                outlined
                hint="Tamanho recomendado: 120x50px"
                persistent-hint
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="banco.ban_logo && !isObject(banco.ban_logo)">
              <v-row no-gutters justify="start" align="center">
                <div v-if="banco.ban_logo">
                  <img alt="Logotipo" :src="banco.ban_logo" class="logotipo">
                </div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="dialogDeletarImagem = true" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                    </template>
                    <span>Remover logotipo</span>
                  </v-tooltip>
                </div>
              </v-row>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditBank()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletarImagem" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Logotipo
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDeletarImagem = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="mb-5">
          Tem certeza que deseja remover o logotipo?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDeletarImagem = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeImagem()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Banco
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Banco <b class="text-primary">{{banco ? banco.ban_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="cancelDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando"
            :loading="salvando"
            @click="removeBanco()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogConfig"
      persistent
      max-width="1000px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="9">
            Opções configuradas para banco: {{banco.ban_nome}}
          </v-col>
          <v-col cols="3" class="text-right">
            <v-icon @click="dialogConfig = false">close</v-icon>
          </v-col>
        </v-row>
        <v-btn @click="dialogNovoTipo = true" color="primary" class="mt-3"><v-icon class="mr-1">account_balance</v-icon>Nova opção</v-btn>
      </v-card>
      <v-card class="ui-dialog-content">
        <div>
          <v-data-table
            :headers="headersConfig"
            :items="dadosConfig"
            :search="searchConfig"
            multi-sort
            fixed-header
            height="400px"
            class="elevation-1 base_table"
            :footer-props="{
              itemsPerPageOptions: [5,10,15,20,25,50,100],
              showFirstLastPage: true,
              firstIcon: 'skip_previous',
              lastIcon: 'skip_next',
              prevIcon: 'chevron_left',
              nextIcon: 'chevron_right'
            }"
            :header-props="{
              sortIcon: 'north',
            }"
          >
            <template v-slot:top>
              <v-row no-gutters align="center" justify="space-between">
                <div class="py-2 px-2 table_search_area">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="searchConfig"
                    outlined
                    label="Busca"
                  ></v-text-field>
                </div>
                <div>
                  <v-menu
                    bottom
                    center
                    offset-y
                    max-height="400"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        Exportar
                        <v-icon>arrow_drop_down</v-icon>
                      </div>
                    </template>
                    <v-list>
                      <v-list-item @click="exportXls('opcoes')">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">receipt_long</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para XLS</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </v-row>
            </template>
            <template v-slot:item.bop_tipo="{ item }">
              {{ calculos[item.bop_tipo - 1].text }}
            </template>
            <template v-slot:item.bop_parcelas="{ item }">
              {{ item.bop_parcelas }}x
            </template>
            <template v-slot:item.bop_entrada="{ item }">
              {{ item.bop_entrada.replace('.', ',') }}%
            </template>
            <template v-slot:item.bop_juro_mensal="{ item }">
              {{ item.bop_juro_mensal.replace('.', ',') }}%
            </template>
            <template v-slot:item.actions="{ item }">
              <v-row no-gutters align="center" justify="center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="openDialogTipo(item)" color="primary" class="mr-2">
                      edit
                    </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="openDialogDeleteTipo(item)" color="primary" class="ml-2">
                      delete
                    </v-icon>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>
              </v-row>
            </template>
          </v-data-table>
        </div>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            @click="dialogConfig = false"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogNovoTipo"
      persistent
      max-width="500px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{tipo.uuid_bop_id ? 'Editar opção' : 'Nova opção'}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogTipo()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formTipos">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-switch
                hide-details
                class="ml-4 mt-0 mb-2"
                color="success"
                v-model="tipo.bop_padrao"
                :loading="salvando"
                :disabled="salvando"
                label="Padrão nas propostas"
              ></v-switch>
            </v-col>
            <v-col v-if="$root.Permissions.admin() && !banco.uuid_int_id" cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="tipo.uuid_int_id"
                :items="integradoresCadastro"
                clearable
                clear-icon="close"
                label="Integrador"
                append-icon="expand_more"
                :loading="salvando"
                :disabled="salvando"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
              <v-text-field
                v-model="tipo.bop_nome"
                label="Nome* Ex: Financiamento PF ou Financiamento PJ"
                :rules="[rules.required]"
                autofocus
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-autocomplete
                v-model="tipo.bop_tipo"
                autocomplete="on"
                :items="calculos"
                :rules="[rules.required]"
                :loading="salvando"
                :disabled="salvando"
                label="Tipo de cálculo*"
                append-icon="expand_more"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="tipo.bop_parcelas"
                label="Qtde de parcelas em meses* Ex: 24"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0">
              <v-text-field
                v-model="tipo.bop_entrada"
                label="Percentual de entrada*"
                suffix="(%)"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0">
              <v-text-field
                v-model="tipo.bop_juro_mensal"
                label="Taxa de juros mensal"
                suffix="(%)"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialogTipo()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditTipo()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogTipoExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Opção
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelDeleteTipo()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Tipo <b class="text-primary">{{tipo ? tipo.tip_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="cancelDeleteTipo()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando"
            :loading="salvando"
            @click="removeTipo()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
export default {
  watch: {
    options: {
      handler () {
        this.getBancos()
      },
      deep: true
    }
  },
  data () {
    return {
      loading: true,
      salvando: false,
      carregando: false,
      dialogNovo: false,
      dialogExcluir: false,
      dialogDeletarImagem: false,
      dialogConfig: false,
      search: '',
      modulos: [],
      options: {},
      total: 0,
      distribuidorAnterior: null,
      integradores: [],
      distribuidores: [],
      integradoresCadastro: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'ban_id'
        },
        { text: 'Nome', value: 'ban_nome' },
        { text: 'Imagem', value: 'ban_logo' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 130
        }
      ],
      dados: [],
      rules: {
        required: value => !!value || 'Obrigatório.',
        min: v => v.length >= 6 || 'Mínimo 6 caracteres',
        size: value => !value || value.size < 10000000 || 'Imagem precisa ter menos que 10MB!'
      },
      banco: {
        ban_nome: '',
        ban_logo: '',
        uuid_int_id: ''
      },
      headersConfig: [
        {
          text: 'ID',
          align: 'start',
          value: 'bop_id'
        },
        { text: 'Nome', value: 'bop_nome' },
        { text: 'Tipo de cálculo', value: 'bop_tipo' },
        { text: 'Parcelas', value: 'bop_parcelas' },
        { text: 'Entrada', value: 'bop_entrada' },
        { text: 'Taxa de juros mensal', value: 'bop_juro_mensal' },
        { text: 'Banco', value: 'banco.ban_nome' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dadosConfig: [],
      searchConfig: '',
      dialogNovoTipo: false,
      dialogTipoExcluir: false,
      calculos: [
        {
          text: 'Tabela Price',
          value: 1
        },
        {
          text: 'Tabela Sac',
          value: 2
        }
      ],
      tipo: {
        bop_nome: '',
        bop_tipo: 1,
        bop_padrao: false,
        bop_parcelas: '',
        bop_entrada: '',
        bop_juro_mensal: ''
      },
      distribuidor: null,
      integrador: null
    }
  },
  methods: {
    async exportXls (type = null) {
      this.loadingXls = true
      Api.post('relatorios/exportar', {
        headers: this.someHeader(!type ? this.headers : this.headersConfig),
        distribuidor: this.distribuidor ? this.distribuidor : null,
        integrador: this.integrador ? this.integrador : null,
        banco: this.banco ? this.banco.uuid_ban_id : null,
        type: !type ? 'bancos' : 'opcoes-financimaneto',
        busca: !type ? this.search : this.searchFinanciamento
      })
        .then(res => {
          this.downloadXls(res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    someHeader (headers) {
      let cabecalhos = []
      headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários' && header.text !== 'Imagem') cabecalhos.push(header)
      })
      return cabecalhos
    },
    loadFunctions () {
      let filters = this.$route.query
      if (filters.busca) this.search = filters.busca
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      this.removeHeader()
      this.getDistributors()
      this.getIntegrators(this.distribuidor)
      this.loading = false
    },
    limparBusca () {
      this.search = null
      this.options.page = 1
      this.applyFilter()
    },
    applyFilter () {
      if (this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) {
        this.integrador = ''
      }
      this.carregando = true

      let query = Object.assign({},
        this.search ? { busca: this.search } : '',
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : ''
      )

      this.$router.replace({name: this.$route.name, query: query}).catch(() => {})

      this.options.page = 1
      this.distribuidorAnterior = this.distribuidor
      this.getIntegrators(this.distribuidor)
      this.getBancos()
    },
    getDistributors () {
      Api.get('distribuidores')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_dis_id,
                text: item.dis_nome_fantasia
              })
            })
            this.distribuidores = info
          }
        })
    },
    async getIntegrators (distribuidor = null, cadastro = false) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `distribuidores/${distribuidor}/integradores`
      }
      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          if (cadastro || (!cadastro && !distribuidor)) {
            this.integradoresCadastro = arrayInt
          }

          if (!cadastro) {
            this.integradores = arrayInt
          }
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    isObject (val) {
      if (val) {
        return val instanceof Object
      } else {
        return true
      }
    },
    async getBancos () {
      this.carregando = true
      this.total = 0

      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 10
      let endpoint = ''

      if (page) pagina = page
      if (itemsPerPage) itensPagina = itemsPerPage
      if (this.search) endpoint += `&busca=${this.search}`
      if (this.distribuidor && !this.integrador) endpoint += '&distribuidor=' + this.distribuidor
      if (this.integrador) endpoint += '&integrador=' + this.integrador

      await Api.get(`bancos?page=${pagina}&per_page=${itensPagina}${endpoint}`)
        .then(res => {
          let info = []
          if (res.data) {
            if (res.data.data.length > 0) {
              res.data.data.map(item => {
                info.push({
                  ban_id: item.ban_id,
                  ban_nome: item.ban_nome,
                  ban_logo: item.ban_logo,
                  uuid_ban_id: item.uuid_ban_id,
                  uuid_int_id: item.integrador ? item.integrador.uuid_int_id : null,
                  int_nome: item.integrador ? item.integrador.int_nome : 'Não vinculado',
                  opcoes: item.opcoes
                })
              })
            }
            this.total = res.data.total
          }
          this.dados = info
          console.log(this.dados, 'this.dados')
          this.loading = false
          this.carregando = false
        })
        .catch(err => {
          this.loading = false
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os bancos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    removeHeader () {
      if (!this.$root.Permissions.admin()) {
        delete this.headersConfig[2]
      }
    },
    removeImagem () {
      this.banco.ban_logo = ''
      this.banco.remover_imagem = true
      this.dialogDeletarImagem = false
    },
    saveEditBank () {
      if (!this.$refs.formBancos.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'bancos/novo'
      let editado = false
      if (this.banco.uuid_ban_id) {
        endpoint = 'bancos/edita'
        editado = true
      }
      if (this.$refs.file) {
        this.banco.imagem = this.$refs.file.fileRecords
      }
      const formData = new FormData()
      Object.keys(this.banco).map((key) => {
        if (key === 'imagem') {
          if (this.$refs.file) {
            if (this.$refs.file.fileRecords && this.$refs.file.fileRecords.length > 0) {
              formData.append(`ban_logo`, this.banco.ban_logo[0].file)
            }
          }
        } else {
          if (this.banco[key] != null) {
            formData.append(key, this.banco[key])
          }
        }
      })
      Api.post(endpoint, formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Banco atualizado com sucesso!' : 'Banco cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getBancos()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    resetBankFields () {
      this.bancos = {
        ban_nome: '',
        ban_logo: '',
        uuid_int_id: ''
      }
    },
    saveEditTipo () {
      if (!this.$refs.formTipos.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'opcoes/novo'
      let editado = false
      if (this.tipo.uuid_bop_id) {
        endpoint = 'opcoes/edita'
        editado = true
      }
      Api.post(`bancos/${this.banco.uuid_ban_id}/${endpoint}`, this.tipo)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Opção atualizada com sucesso!' : 'Opção cadastrada com sucesso!',
            color: 'success'
          })
          this.getBancos()
          this.closeDialogTipo()
          this.openDialogConfig(this.banco)
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeBanco () {
      this.salvando = true
      Api.delete(`bancos/remove/${this.banco.uuid_ban_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getBancos()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover banco!',
            color: 'error'
          })
        })
    },
    openNovo (item) {
      this.banco = JSON.parse(JSON.stringify(item))
      this.dialogNovo = true
    },
    async openDialogConfig (item) {
      this.banco = JSON.parse(JSON.stringify(item))
      await Api.get(`bancos/${this.banco.uuid_ban_id}/opcoes`)
        .then(res => {
          let info = []
          if (res.data) {
            if (res.data.length > 0) {
              info = res.data
            }
          }
          this.dadosConfig = info
        })
        .catch(err => {
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os bancos!',
            color: 'error'
          })
          console.log(err)
        })
      this.dialogConfig = true
    },
    openDialogTipo (item) {
      this.loading = true
      this.dialogNovoTipo = true
      Api.get(`bancos/${this.banco.uuid_ban_id}/opcoes/${item.uuid_bop_id}`)
        .then((response) => {
          this.loading = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          let opcao = response.data
          this.tipo = {
            uuid_bop_id: opcao.uuid_bop_id,
            bop_nome: opcao.bop_nome,
            bop_tipo: opcao.bop_tipo,
            bop_padrao: opcao.bop_padrao,
            bop_parcelas: opcao.bop_parcelas,
            bop_entrada: opcao.bop_entrada,
            bop_juro_mensal: opcao.bop_juro_mensal,
            uuid_int_id: opcao.integrador ? opcao.integrador.uuid_int_id : null
          }
        })
        .catch((error) => {
          this.loading = false
          this.dialogNovoTipo = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro ao carregar dados da opção!',
            color: 'error'
          })
        })
    },
    openDialogDeleteTipo (item) {
      this.tipo = JSON.parse(JSON.stringify(item))
      this.dialogTipoExcluir = true
    },
    openDialogDelete (item) {
      this.banco = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    cancelDeleteTipo () {
      this.closeDialogTipo()
      this.dialogTipoExcluir = false
    },
    closeDialogTipo () {
      this.tipo = {
        bop_nome: '',
        bop_tipo: 1,
        bop_padrao: false,
        bop_parcelas: '',
        bop_entrada: '',
        bop_juro_mensal: ''
      }
      if (this.$refs.formTipos) {
        this.$refs.formTipos.resetValidation()
      }
      this.dialogNovoTipo = false
    },
    removeTipo () {
      this.salvando = true
      Api.delete(`bancos/${this.banco.uuid_ban_id}/opcoes/remove/${this.tipo.uuid_bop_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.dialogTipoExcluir = false
          this.salvando = false
          this.openDialogConfig(this.banco)
          this.closeDialogTipo()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover opção!',
            color: 'error'
          })
        })
    },
    closeDialog () {
      this.banco = {
        ban_nome: '',
        ban_logo: '',
        uuid_int_id: ''
      }
      if (this.$refs.formBancos) {
        this.$refs.formBancos.resetValidation()
      }
      this.dialogNovo = false
      this.resetBankFields()
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.logotipo {
  max-height: 250px;
  max-width: 250px;
}
.v-file-input {
  >>>.v-input__prepend-outer {
    margin-top: 10px!important;
  }
}
.banco_imagem {
  max-height: 100px;
  margin: 5px 0;
  max-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuracoes/Bancos.vue